module.exports = __webpack_public_path__ + "media/pages/book/components/images/app-reviews/en/handyman-4b85156a7be4618ed5a0eed60c5abfe9.jpg";